import SessionHelper from "../Helper/SessionHelper";
class CartListRequest{
    CartListURL(){
        return process.env.REACT_APP_BASEURL+"CartList/"+SessionHelper.getMobile();
    }
}
export const {CartListURL}=new CartListRequest();